import { UserSurveyPriority } from 'Generated/graphql-types'

const config = { domain: 'Impact', subdomain: 'Dashboard' }

interface UserAccountDetails {
  userId: number
  userEmail: string
  orgId: number
  platformPlan: string | null
  funderOrgId: number | null
}

interface CategoryFilterParams {
  category: string | string[]
  UserAccountDetails: UserAccountDetails
}

interface FilterByPrioritiesParams {
  priorities: UserSurveyPriority[]
  UserAccountDetails: UserAccountDetails
}

interface GoalTitleFilterParams {
  goalTitle: string | string[]
  UserAccountDetails: UserAccountDetails
}

interface TaskParams {
  taskTitle: string
  taskId: number
  goalTitle: string
  goalId: number
  isCompleted: boolean | null | undefined
  UserAccountDetails: UserAccountDetails
}

interface GoalClickedParams {
  goalTitle: string
  goalId: number
  goalCategory: string
  UserAccountDetails: UserAccountDetails
}

interface GoalCommentClickedParams {
  goalTitle: string
  goalId: number
  commentId: number
  commentOwnerId: number
  UserAccountDetails: UserAccountDetails
}

interface AcademyResourceClickedParams {
  academyReourceTitle: string
  academyResourceType: string
  academyResourceCategory: string
  academyResourceId: string
  UserAccountDetails: UserAccountDetails
}

interface ProgressUpdateGoalClickedParams {
  goalTitle: string
  goalId: number
  goalCategory: string
  updateId: number
  progressUpdateValue: string
  UserAccountDetails: UserAccountDetails
}

export const impactReportDashboard = {
  Report_Teammate_Filter_Clicked: {
    Report_Teammate_Filter_Clicked: (param: UserAccountDetails) => param,
    config,
  },
  Report_Teammate_Filter_Cleared: {
    Report_Teammate_Filter_Cleared: (param: UserAccountDetails) => param,
    config,
  },
  Report_Category_Filter_Clicked: {
    Report_Category_Filter_Clicked: (param: CategoryFilterParams) => param,
    config,
  },
  Report_Priorities_Filter_Clicked: {
    Report_Priorities_Filter_Clicked: (param: FilterByPrioritiesParams) =>
      param,
    config,
  },
  Report_Goal_Title_Filter_Clicked: {
    Report_Goal_Title_Filter_Clicked: (param: GoalTitleFilterParams) => param,
    config,
  },
  Report_All_Filter_Cleared: {
    Report_All_Filter_Clear_Clicked: (param: UserAccountDetails) => param,
    config,
  },
  Report_Task_Clicked: {
    Report_Task_Clicked: (param: TaskParams) => param,
    config,
  },
  Report_Goal_Clicked: {
    Report_Goal_Clicked: (param: GoalClickedParams) => param,
    config,
  },
  Report_Comment_Clicked: {
    Report_Comment_Clicked: (param: GoalCommentClickedParams) => param,
    config,
  },
  Report_Academy_Resource_Clicked: {
    Report_Academy_Resource_Clicked: (param: AcademyResourceClickedParams) =>
      param,
    config,
  },
  Report_Progress_Update_Goal_Clicked: {
    Report_Progress_Update_Goal_Clicked: (
      param: ProgressUpdateGoalClickedParams
    ) => param,
    config,
  },
}
